import { Link } from "react-router-dom";
import { ArrowRight, Target, Zap, Compass } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

const ABOUT_IMG = "";

const valueIcons = [Target, Zap, Compass];

export default function About() {
    useDocumentMeta("about", "/about");
    const { t } = useI18n();
    const a = t.about;

    return (
        <div data-testid="about-page" className="bg-white">
            <section className="border-b-2 border-black">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
                    <div className="overline mb-5">{a.headerOverline}</div>
                    <h1 className="font-display text-6xl md:text-7xl lg:text-8xl uppercase leading-[0.85] text-black max-w-5xl">
                        {a.headerTitle1}
                        <br />
                        {a.headerTitle2}
                        <br />
                        <span className="text-[#FF5A00]">{a.headerTitle3}</span>
                    </h1>
                </div>
            </section>

            <section className="border-b-2 border-black">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                        <div>
                            <div className="overline mb-4">{a.storyOverline}</div>
                            <h2 className="font-display text-5xl md:text-6xl uppercase leading-none text-black">
                                {a.storyTitle1}
                                <br />
                                {a.storyTitle2}
                            </h2>
                            <div className="mt-8 space-y-5 text-zinc-700 font-medium text-lg leading-relaxed">
                                <p>{a.storyP1}</p>
                                <p>{a.storyP2}</p>
                                <p>{a.storyP3}</p>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </section>

            <section className="bg-black text-white border-b-2 border-black">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 md:gap-y-0">
                        {a.stats.map(([n, l], i) => (
                            <div
                                key={l}
                                className={`px-4 ${i !== 3 ? "md:border-r-2 md:border-zinc-700" : ""}`}
                                data-testid={`stat-${i}`}
                            >
                                <div className="font-display text-6xl md:text-7xl text-[#FF5A00] leading-none">
                                    {n}
                                </div>
                                <div className="mt-3 text-xs uppercase tracking-[0.3em] font-bold text-zinc-300">
                                    {l}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="bg-zinc-100 border-b-2 border-black">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                    <div className="overline mb-4">{a.valuesOverline}</div>
                    <h2 className="font-display text-5xl md:text-6xl uppercase leading-none text-black max-w-3xl">
                        {a.valuesTitle}
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
                        {a.values.map((v, idx) => {
                            const Icon = valueIcons[idx];
                            return (
                                <div key={v.title} className="brutal-card p-8" data-testid={`value-${idx}`}>
                                    <div className="w-12 h-12 bg-[#FF5A00] flex items-center justify-center border-2 border-black">
                                        <Icon className="w-6 h-6 text-black" strokeWidth={2.5} />
                                    </div>
                                    <h3 className="font-display text-3xl uppercase mt-6 text-black">{v.title}</h3>
                                    <p className="mt-3 text-zinc-700 font-medium leading-relaxed">{v.desc}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            <section className="bg-white border-b-2 border-black">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                    <div className="border-2 border-black p-10 md:p-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8 bg-white shadow-[12px_12px_0px_#FF5A00]">
                        <div>
                            <div className="overline mb-4">{a.ctaOverline}</div>
                            <h2 className="font-display text-4xl md:text-5xl uppercase leading-none text-black max-w-2xl">
                                {a.ctaTitle}
                            </h2>
                        </div>
                        <Link to="/contact" data-testid="about-cta" className="brutal-btn">
                            {a.ctaBtn} <ArrowRight className="w-4 h-4" />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
